import { $isLinkNode, $isAutoLinkNode } from '@lexical/link';
import { $findMatchingParent } from '@lexical/utils';
import { $isRangeSelection, $isLineBreakNode } from 'lexical';

/**
 * Check if the entire selection is uniformly within the same link
 * Based on Lexical playground patterns
 */
export function selectionIsUniformLink(selection: any): boolean {
  if (!$isRangeSelection(selection)) return false;

  const focusNode = selection.focus.getNode();
  const focusLink =
    $findMatchingParent(focusNode, $isLinkNode) || $findMatchingParent(focusNode, $isAutoLinkNode);

  if (!focusLink) return false;

  // Check all nodes in selection to ensure they're all in the same link
  const badNode = selection
    .getNodes()
    .filter((n: any) => !$isLineBreakNode(n))
    .find((n: any) => {
      const nodeLink =
        $findMatchingParent(n, $isLinkNode) || $findMatchingParent(n, $isAutoLinkNode);
      return (
        !nodeLink ||
        !nodeLink.is(focusLink) ||
        ($isAutoLinkNode(nodeLink) && nodeLink.getIsUnlinked?.())
      );
    });

  return !badNode;
}

/**
 * Get link information from current selection with uniformity check
 */
export function getUniformLinkInfo(selection: any) {
  if (!selectionIsUniformLink(selection)) {
    return { url: '', key: null, linkNode: null, isUniform: false };
  }

  const focusNode = selection.focus.getNode();
  const linkNode =
    $findMatchingParent(focusNode, $isLinkNode) || $findMatchingParent(focusNode, $isAutoLinkNode);

  if (!linkNode) {
    return { url: '', key: null, linkNode: null, isUniform: false };
  }

  try {
    const url = (linkNode as any).getURL() ?? '';
    const key = (linkNode as any)?.__key ?? null;
    return { url, key, linkNode, isUniform: true };
  } catch {
    return { url: '', key: null, linkNode: null, isUniform: false };
  }
}
